export default "__VITE_ASSET__CjjOHwFb__"